import "./index.css";

import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import "./@api/interceptor";
const container = document.getElementById("root");
if (!container) throw new Error("Root container not found");

createRoot(container).render(<RouterProvider router={router} />);
